import { Check, X } from "lucide-react";
import { PROFESSION_IDS, PROF_T } from "../content/professions";

export const matchProf = (sel, profs) => !sel.length || (profs || []).some((p) => sel.includes(p));

export default function ProfessionFilter({ value, onChange, testid = "prof-filter" }) {
  const N = PROF_T.sk.names;
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div className="flex flex-wrap items-center gap-2 mb-6" data-testid={testid}>
      <span className="text-xs uppercase tracking-[0.18em] text-white/40 mr-1">Profesia:</span>
      {PROFESSION_IDS.map((id) => {
        const on = value.includes(id);
        return (
          <button key={id} type="button" onClick={() => toggle(id)} data-testid={`${testid}-${id}`}
            className={`inline-flex items-center gap-1 px-3 py-1.5 text-xs border transition-colors ${on ? "border-[#D4AF37] bg-[#D4AF37]/15 text-[#F2E3C6]" : "border-white/15 text-white/55 hover:border-[#D4AF37]/50"}`}>
            {on && <Check size={12} className="text-[#D4AF37]" />} {N[id]}
          </button>
        );
      })}
      {value.length > 0 && (
        <button type="button" onClick={() => onChange([])} data-testid={`${testid}-clear`}
          className="inline-flex items-center gap-1 px-2 py-1.5 text-xs text-white/40 hover:text-white">
          <X size={12} /> Zrušiť filter
        </button>
      )}
    </div>
  );
}
